export default "__VITE_ASSET__$vKM3i7z__"